/* eslint-disable react/prop-types */
import qs from 'qs';
import React, { useEffect, useState } from 'react';
import { Col, FlexboxGrid } from 'rsuite';
import SelectInput from '~/components/selectInput/SelectInput';
import api from '~/services/api';

export default function SelectMenu({ setForm, form }) {
  const [moduloData, setModuloData] = useState([{}]);
  const [menuData, setMenuData] = useState([{}]);

  useEffect(() => {
    async function getData() {
      const params = {
        skip: 0,
        take: 1000,
      };
      await api.get(`/Modulo?${qs.stringify(params)}`).then((response) => {
        const { data } = response.data;
        setModuloData(data);
      });
    }
    getData();
  }, []);

  useEffect(() => {
    async function getData() {
      const params = {
        idModulo: form.idModulo,
        skip: 0,
        take: 1000,
      };
      await api.get(`/Menu?${qs.stringify(params)}`).then((response) => {
        const { data } = response.data;
        setMenuData(data);
      });
    }
    getData();
  }, [form.idModulo]);

  return (
    <FlexboxGrid align="top" style={{ marginTop: '16px' }}>
      <FlexboxGrid.Item componentClass={Col} colspan={24} md={12}>
        <SelectInput
          margin="0"
          width="100%"
          label="Selecione o módulo"
          form={form}
          valueKey="id"
          labelKey="nome"
          setForm={setForm}
          value={form.idModulo}
          options={moduloData}
          placeholder="Escolha uma opção"
          state="idModulo"
        />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item componentClass={Col} colspan={24} md={12}>
        <SelectInput
          margin="0"
          width="100%"
          label="Selecione o menu"
          form={form}
          valueKey="id"
          labelKey="nome"
          setForm={setForm}
          value={form.idMenu}
          options={menuData}
          placeholder="Escolha uma opção"
          state="idMenu"
          disabled={!form.idModulo}
          onChange={() => {}}
        />
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
}
